import { RpcEngine } from '../core/rpc.js'

/**
 * Shared lightweight Markdown → HTML renderer.
 * Handles: bold+italic, bold, italic, inline code, line breaks.
 * All input is HTML-escaped first to prevent XSS.
 * Exported so MdRenderer and other consumers share one implementation.
 */
export function renderMarkdown(text: string): string {
  return text
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`(.+?)`/g, '<code>$1</code>')
    .replace(/\n/g, '<br>')
}

export class UtilsModule {
  constructor(private _rpc: RpcEngine) {}

  clipboard = {
    writeText: (text: string): Promise<void> => navigator.clipboard.writeText(text),
    readText: (): Promise<string> => navigator.clipboard.readText(),
  }

  format = {
    /** Convert basic Markdown to safe HTML (bold, italic, inline code, line breaks). */
    markdown: renderMarkdown,
    /** Escape arbitrary text so it is safe to inject into innerHTML. */
    sanitize: (html: string): string => {
      const div = document.createElement('div')
      div.textContent = html
      return div.innerHTML
    },
  }
}
